import { useState, useEffect, useRef } from "react";
import { apiFetch } from "./utils";
import { BRAND, KofidesLogo, Lbl, Inp, Slct, Btn } from "./ui";

var CAT_DOC_DEFAULT=["Constancia de Situacion Fiscal","Opinion de Cumplimiento SAT","Opinion de Cumplimiento IMSS","Opinion de Cumplimiento INFONAVIT","Otro documento"];
var CAT_OBL_DEFAULT=["ISR mensual (pagos provisionales)","IVA mensual","IMSS patron","INFONAVIT","ISR anual (declaracion anual)","DIOT mensual","ISR retenciones honorarios","IVA retenciones honorarios","Nomina bimestral (RESICO)","PTU","Impuesto Sobre Nominas (ISN)","Declaracion informativa anual","Otro"];

// Días de prórroga según último dígito numérico del RFC antes de la homoclave (Art. 12 CFF)
// SAT Art.12 CFF: RFC digit → días hábiles de prórroga sobre la fecha base
var _PRORROGA_RFC={"1":1,"2":1,"3":2,"4":2,"5":3,"6":3,"7":4,"8":4,"9":5,"0":5};

function fmtDate(iso){
  if(!iso)return null;
  var p=String(iso).split("-");
  if(p.length!==3||p[0].length!==4)return iso;
  return p[2]+"-"+p[1]+"-"+p[0];
}

function _esHabil(d,festSet){
  var dw=d.getDay();
  if(dw===0||dw===6)return false;
  return !festSet.has(d.toISOString().slice(0,10));
}

function _avanzarHabil(d,festSet){
  var r=new Date(d); r.setDate(r.getDate()+1);
  while(!_esHabil(r,festSet))r.setDate(r.getDate()+1);
  return r;
}

function _sumarDiasHabiles(d,n,festSet){
  var cur=new Date(d);
  while(!_esHabil(cur,festSet))cur.setDate(cur.getDate()+1);
  for(var i=0;i<n;i++)cur=_avanzarHabil(cur,festSet);
  return cur;
}

function Campo2(props){
  var lbl=<label style={{fontSize:11,fontWeight:600,color:"#6b7280",textTransform:"uppercase",letterSpacing:"0.05em",display:"block",marginBottom:4}}>{props.label}</label>;
  if(!props.editable){var disp=props.type==="date"?fmtDate(props.value):props.value;return <div><div style={{marginBottom:4}}>{lbl}</div><div style={{padding:"8px 12px",background:"#f9fafb",borderRadius:8,fontSize:14,color:"#1f2937",border:"1px solid transparent",minHeight:38}}>{disp||<span style={{color:"#d1d5db"}}>{"—"}</span>}</div></div>;}
  if(props.options)return <div><div style={{marginBottom:4}}>{lbl}</div><select value={props.value||""} onChange={function(e){props.onChange(e.target.value);}} style={{width:"100%",padding:"8px 12px",border:"1px solid #d1d5db",borderRadius:8,fontSize:14,background:"#fff",outline:"none"}}><option value="">Seleccionar...</option>{props.options.map(function(o){return <option key={o} value={o}>{o}</option>;})}</select></div>;
  return <div><div style={{marginBottom:4}}>{lbl}</div><input type={props.type||"text"} value={props.value!=null?props.value:""} onChange={function(e){props.onChange(e.target.value);}} style={{width:"100%",padding:"8px 12px",border:"1px solid #d1d5db",borderRadius:8,fontSize:14,outline:"none",boxSizing:"border-box"}}/></div>;
}

function Sec2(props){
  return <div style={{background:"#fff",borderRadius:12,border:"1px solid #e5e7eb",overflow:"hidden",marginBottom:16}}>
    <div style={{display:"flex",alignItems:"center",gap:8,padding:"12px 20px",background:"linear-gradient(to right,#eef2ff,#fff)",borderBottom:"1px solid #f3f4f6"}}>
      <span style={{fontSize:16}}>{props.icon}</span>
      <h3 style={{fontSize:14,fontWeight:600,color:"#1f2937",margin:0}}>{props.titulo}</h3>
    </div>
    <div style={{padding:20}}>{props.children}</div>
  </div>;
}

export function DatosFiscalesModule(p) {
  var uid = p.user.id;
  var _role = p.role || p.user.role;
  var canEdit = _role === "superadmin" || _role === "contador";
  var hoy = new Date().toISOString().slice(0,10);
  var BLANK = {rfc:"",nombre_razon_social:"",curp:"",tipo_persona:"moral",nombre_comercial:"",representante_legal:"",primer_apellido:"",segundo_apellido:"",fecha_inicio_ops:"",fecha_inicio_kofides:"",estatus:"Activo",venc_efirma:"",venc_csd:"",email:"",telefono:"",cp:"",tipo_vialidad:"",nombre_vialidad:"",num_exterior:"",num_interior:"",colonia:"",localidad:"",municipio:"",entidad:"",regimen:""};
  var [data,setData]=useState(BLANK);
  var [borrador,setBorrador]=useState(BLANK);
  var [editando,setEditando]=useState(false);
  var [actividades,setActividades]=useState([]);
  var [obligaciones,setObligaciones]=useState([]);
  var [documentos,setDocumentos]=useState([]);
  var [diasInhabiles,setDiasInhabiles]=useState([]);
  var [loading,setLoading]=useState(true);
  var [saving,setSaving]=useState(false);
  var [msg,setMsg]=useState("");
  var [catObl,setCatObl]=useState([]);
  var [catDoc,setCatDoc]=useState(CAT_DOC_DEFAULT);
  var [tipoNuevoDoc,setTipoNuevoDoc]=useState(CAT_DOC_DEFAULT[0]);
  var [anioTrabajo,setAnioTrabajo]=useState(new Date().getFullYear());
  var [nuevaFecha,setNuevaFecha]=useState("");
  var [nAct,setNAct]=useState({descripcion:"",porcentaje:"100",fecha_inicio:""});
  var [nObl,setNObl]=useState({nombre:"",fecha_inicio:""});
  var [nCatObl,setNCatObl]=useState({nombre:"",tipo:"mensual17"});
  var [savingCat,setSavingCat]=useState(false);
  var fileInputRef=useRef();

  useEffect(function(){
    Promise.all([
      apiFetch("/datos-fiscales/"+uid).then(function(r){return r.json();}),
      apiFetch("/datos-fiscales/"+uid+"/actividades").then(function(r){return r.json();}),
      apiFetch("/datos-fiscales/"+uid+"/obligaciones").then(function(r){return r.json();}),
      apiFetch("/datos-fiscales/"+uid+"/documentos").then(function(r){return r.json();}),
      apiFetch("/catalogo/dias-inhabiles").then(function(r){return r.json();}),
      apiFetch("/config/cat_obl").then(function(r){return r.json();}),
      apiFetch("/config/cat_doc").then(function(r){return r.json();}),
    ]).then(function(results){
      var d=results[0].data||BLANK; setData(d); setBorrador(d);
      setActividades(results[1].actividades||[]);
      setObligaciones((results[2].obligaciones||[]).filter(function(o){return o&&o.id;}));
      setDocumentos(results[3].documentos||[]);
      setDiasInhabiles(results[4].dias||[]);
      var co=(results[5].value&&results[5].value.length>0)?results[5].value:CAT_OBL_DEFAULT;
      console.log("[DatosFiscales] catObl=",co);
      setCatObl(co);
      var cd=(results[6].value&&results[6].value.length>0)?results[6].value:CAT_DOC_DEFAULT;
      setCatDoc(cd); setTipoNuevoDoc(cd[0]);
      setLoading(false);
    }).catch(function(){setLoading(false);});
  },[uid]);

  var ESTATUS_OPTS=["Activo","Suspendido","Cancelado","Baja temporal","En liquidacion"];
  var TIPOS_VIALIDAD=["Calle","Avenida","Boulevard","Calzada","Privada","Andador","Callejon","Carretera","Cerrada"];
  var REGIMENES_OPTS=["601 - General de Ley Personas Morales","603 - Personas Morales con Fines no Lucrativos","605 - Sueldos y Salarios e Ingresos Asimilados a Salarios","606 - Arrendamiento","607 - Regimen de Enajenacion o Adquisicion de Bienes","608 - Demas ingresos","610 - Residentes en el Extranjero sin Establecimiento Permanente en Mexico","611 - Ingresos por Dividendos","612 - Personas Fisicas con Actividades Empresariales y Profesionales","614 - Ingresos por intereses","615 - Regimen de los ingresos por obtencion de premios","616 - Sin obligaciones fiscales","620 - Sociedades Cooperativas de Produccion","621 - Incorporacion Fiscal","622 - Actividades Agricolas Ganaderas Silvicolas y Pesqueras","623 - Opcional para Grupos de Sociedades","624 - Coordinados","625 - Regimen de las Actividades Empresariales con ingresos a traves de Plataformas Tecnologicas","626 - Regimen Simplificado de Confianza (RESICO)"];

  function setCampo(k,v){setBorrador(function(b){return Object.assign({},b,{[k]:v});});}
  function iniciarEdicion(){setBorrador(data);setEditando(true);}
  function cancelar(){setBorrador(data);setEditando(false);}

  function guardar(){
    var payload=Object.assign({},borrador,{fecha_ultimo_cambio:hoy});
    setSaving(true);
    console.log("[guardar] uid="+uid+" payload=",payload);
    apiFetch("/datos-fiscales/"+uid,{method:"PUT",body:JSON.stringify(payload)})
      .then(function(r){
        console.log("[guardar] HTTP status="+r.status);
        if(!r.ok){return r.text().then(function(t){throw new Error("HTTP "+r.status+": "+t);});}
        return r.json();
      })
      .then(function(resp){
        console.log("[guardar] respuesta servidor=",resp);
        setData(payload);setBorrador(payload);setEditando(false);setSaving(false);
        setMsg("Guardado correctamente");setTimeout(function(){setMsg("");},3000);
      })
      .catch(function(e){
        console.error("[guardar] error=",e);
        setSaving(false);setMsg("Error al guardar: "+(e&&e.message?e.message:"ver consola"));
      });
  }

  function diasRestantes(fecha){
    if(!fecha)return null;
    var hoyD=new Date(); var f=new Date(fecha);
    return Math.ceil((f-hoyD)/(1000*60*60*24));
  }

  function VencBadge(props){
    var dias=diasRestantes(props.fecha);
    if(dias===null)return <span style={{color:"#9ca3af"}}>—</span>;
    var bg="#dcfce7",color="#16a34a",bdr="#bbf7d0",txt=dias+" dias";
    if(dias<0){bg="#fee2e2";color="#dc2626";bdr="#fecaca";txt="Vencido ("+Math.abs(dias)+"d)";}
    else if(dias<=30){bg="#fee2e2";color="#dc2626";bdr="#fecaca";}
    else if(dias<=60){bg="#fef9c3";color="#ca8a04";bdr="#fde68a";}
    return <span style={{display:"inline-flex",alignItems:"center",gap:4,padding:"2px 10px",borderRadius:20,fontSize:11,fontWeight:600,background:bg,color:color,border:"1px solid "+bdr}}>{dias<=60&&dias>=0?"⚠ ":""}{txt}</span>;
  }

  function addActividad(){
    if(!nAct.descripcion.trim())return;
    var rec={descripcion:nAct.descripcion,porcentaje:parseFloat(nAct.porcentaje)||0,fecha_inicio:nAct.fecha_inicio,orden:actividades.length+1};
    apiFetch("/datos-fiscales/"+uid+"/actividades",{method:"POST",body:JSON.stringify(rec)}).then(function(r){return r.json();}).then(function(d){setActividades(function(a){return a.concat([Object.assign({},rec,{id:d.id})]);});setNAct({descripcion:"",porcentaje:"100",fecha_inicio:""});});
  }
  function delActividad(id){apiFetch("/datos-fiscales/"+uid+"/actividades/"+id,{method:"DELETE"}).then(function(){setActividades(function(a){return a.filter(function(x){return x.id!==id;});});});}

  function addObligacion(){
    if(!nObl.nombre)return;
    var rec={nombre:nObl.nombre,fecha_inicio:nObl.fecha_inicio};
    apiFetch("/datos-fiscales/"+uid+"/obligaciones",{method:"POST",body:JSON.stringify(rec)}).then(function(r){return r.json();}).then(function(d){setObligaciones(function(a){return a.concat([Object.assign({},rec,{id:d.id})]);});setNObl({nombre:"",fecha_inicio:""});});
  }
  function delObligacion(id){apiFetch("/datos-fiscales/"+uid+"/obligaciones/"+id,{method:"DELETE"}).then(function(){setObligaciones(function(a){return a.filter(function(x){return x.id!==id;});});});}

  function subirDocumento(e){
    var file=e.target.files[0]; if(!file)return;
    var fd=new FormData(); fd.append("file",file); fd.append("tipo",tipoNuevoDoc);
    apiFetch("/datos-fiscales/"+uid+"/documentos",{method:"POST",body:fd})
      .then(function(r){return r.json();})
      .then(function(d){if(d.id)setDocumentos(function(a){return a.concat([{id:d.id,tipo:tipoNuevoDoc,nombre_archivo:file.name,fecha_subida:hoy,tamanio:file.size}]);});});
    e.target.value="";
  }
  function _cdFilename(r, fallback){
    var cd=r.headers.get("Content-Disposition")||"";
    var m=cd.match(/filename="?([^"]+)"?/);
    return m?m[1]:fallback;
  }
  function downloadDoc(id){
    apiFetch("/documentos/"+id+"?uid="+uid).then(function(r){
      if(!r.ok){setMsg("No se pudo descargar el documento.");setTimeout(function(){setMsg("");},3000);return;}
      var fname=_cdFilename(r,"documento_"+id);
      return r.blob().then(function(blob){
        var url=URL.createObjectURL(blob);
        var a=document.createElement("a"); a.href=url; a.download=fname;
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
        URL.revokeObjectURL(url);
      });
    }).catch(function(){setMsg("No se pudo descargar el documento.");setTimeout(function(){setMsg("");},3000);});
  }
  function delDocumento(id){apiFetch("/datos-fiscales/"+uid+"/documentos/"+id,{method:"DELETE"}).then(function(){setDocumentos(function(a){return a.filter(function(x){return x.id!==id;});});});}

  function addDia(){
    if(!nuevaFecha)return;
    apiFetch("/catalogo/dias-inhabiles",{method:"POST",body:JSON.stringify({fecha:nuevaFecha,tipo:"movil"})})
      .then(function(){setDiasInhabiles(function(a){return a.concat([{fecha:nuevaFecha,tipo:"movil"}]);});setNuevaFecha("");});
  }
  function delDia(fecha){apiFetch("/catalogo/dias-inhabiles/"+fecha,{method:"DELETE"}).then(function(){setDiasInhabiles(function(a){return a.filter(function(x){return x.fecha!==fecha;});});});}

  function saveCatObl(lista){
    setSavingCat(true);
    apiFetch("/config/cat_obl",{method:"POST",body:JSON.stringify({value:lista})})
      .then(function(){setSavingCat(false);})
      .catch(function(){setSavingCat(false);});
  }
  function addCatObl(){
    if(!nCatObl.nombre.trim())return;
    var entry=nCatObl.nombre.trim();
    if(catObl.includes(entry))return;
    var nueva=catObl.concat([entry]);
    setCatObl(nueva); setNCatObl({nombre:"",tipo:"mensual17"}); saveCatObl(nueva);
  }
  function delCatObl(nombre){
    var nueva=catObl.filter(function(c){return c!==nombre;});
    setCatObl(nueva); saveCatObl(nueva);
  }

  function calcProximoVenc(nombre,rfc,festivos,tipoPer){
    if(!nombre)return null;
    var n=nombre.toLowerCase();
    var hoy=new Date();
    var yr=hoy.getFullYear();
    var mo=hoy.getMonth();
    var da=hoy.getDate();
    var hoyFecha=new Date(yr,mo,da);
    var festSet=new Set((festivos||[]).map(function(f){return typeof f==="string"?f:f.fecha;}));
    // RFC digit → calendar day offset (SAT staggered schedule)
    var digito=rfc&&rfc.length>=4?rfc.slice(-4,-3):"";
    var diasExtra=_PRORROGA_RFC[digito]||0;
    var base=null;
    var sinProrroga=false;
    // IMSS/INFONAVIT → día 17, SIN prorroga RFC
    if(n.includes("imss")||n.includes("infonavit")){
      base=da<=17?new Date(yr,mo,17):new Date(yr,mo+1,17);
      sinProrroga=true;
    }
    // ISN → día 12, SIN prorroga RFC
    else if(n.includes("isn")||n.includes("nominas")){
      base=da<=12?new Date(yr,mo,12):new Date(yr,mo+1,12);
      sinProrroga=true;
    }
    // DIOT → último día del mes en curso, SIN prorroga
    else if(n.includes("diot")){
      base=new Date(yr,mo+1,0);  // día 0 del mes siguiente = último día del mes actual
      if(base<hoy)base=new Date(yr,mo+2,0);
      sinProrroga=true;
    }
    // Contabilidad electrónica → día 5 del mes siguiente, SIN prorroga
    else if(n.includes("contabilidad")){
      base=da<=5?new Date(yr,mo,5):new Date(yr,mo+1,5);
      sinProrroga=true;
    }
    // Mensual con prorroga → día 17; solo salta al mes siguiente si la prorroga del mes en curso ya venció
    else if(n.includes("mensual")||n.includes("isr retenciones")||
            n.includes("iva retenciones")){
      var baseMes=new Date(yr,mo,17);
      var vencMes=_sumarDiasHabiles(baseMes,diasExtra,festSet);
      base=hoyFecha>vencMes?new Date(yr,mo+1,17):baseMes;
    }
    // Bimestral → día 17 del mes siguiente al cierre del bimestre
    else if(n.includes("bimestral")){
      var fins=[1,3,5,7,9,11];
      for(var i=0;i<fins.length;i++){var t=new Date(yr,fins[i]+1,17);if(t>=hoy){base=t;break;}}
      if(!base)base=new Date(yr+1,2,17);
    }
    // Anual → fecha fija por tipo persona, SIN prorroga RFC
    else if((n.includes("anual")||n.includes("declaracion"))&&!n.includes("ptu")){
      var tp=(tipoPer||"moral").toLowerCase();
      if(tp==="fisica"){
        base=new Date(yr+1,3,30);   // 30 abril año siguiente
      } else if(tp.includes("lucro")){
        base=new Date(yr+1,1,15);   // 15 febrero año siguiente
      } else {
        base=new Date(yr+1,2,31);   // 31 marzo año siguiente
      }
      sinProrroga=true;
    }
    // PTU → 31 de mayo
    else if(n.includes("ptu")){
      base=new Date(yr,4,31);if(base<hoy)base=new Date(yr+1,4,31);
      sinProrroga=true;
    }
    if(!base)return null;
    if(sinProrroga){
      // Solo avanzar si cae en inhábil, sin prorroga por dígito RFC
      while(!_esHabil(base,festSet))base.setDate(base.getDate()+1);
      return base.toISOString().slice(0,10);
    }
    // Art. 12 CFF: si la base es inhábil, recorrer al día hábil siguiente; luego sumar los días hábiles de prórroga
    var final=_sumarDiasHabiles(base,diasExtra,festSet);
    return final.toISOString().slice(0,10);
  }

  var fuente=editando?borrador:data;
  var esFisica=fuente.tipo_persona==="fisica";
  var anios=[...new Set(diasInhabiles.map(function(d){return d.fecha.slice(0,4);}) )].sort();
  var diasDelAnio=diasInhabiles.filter(function(d){return d.fecha.startsWith(String(anioTrabajo));});

  if(loading)return <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",color:"#64748b"}}>Cargando...</div>;

  return(
    <div style={{minHeight:"100vh",background:"#f1f5f9",fontFamily:"'Inter','Segoe UI',sans-serif"}}>
      <div style={{background:BRAND,padding:"14px 28px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <KofidesLogo size={28}/>
          <div><p style={{color:"#fff",fontWeight:800,fontSize:15,margin:0,fontFamily:"Georgia,serif",letterSpacing:2}}>KOFIDES</p><p style={{color:"rgba(255,255,255,0.5)",fontSize:11,margin:"2px 0 0"}}>Datos Fiscales</p></div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <div style={{width:32,height:32,background:BRAND,borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:13,fontWeight:700,border:"2px solid rgba(255,255,255,0.3)"}}>{p.user.name[0]}</div>
          <span style={{fontSize:13,fontWeight:600,color:"#fff"}}>{p.user.name}</span>
          <button onClick={p.onBack} style={{background:"rgba(255,255,255,0.15)",border:"none",borderRadius:8,padding:"7px 13px",color:"#fff",fontSize:12,cursor:"pointer",fontWeight:600}}>Inicio</button>
          <button onClick={p.onLogout} style={{background:"rgba(255,100,100,0.3)",border:"none",borderRadius:8,padding:"7px 13px",color:"#fff",fontSize:12,cursor:"pointer",fontWeight:600}}>Salir</button>
        </div>
      </div>
      <div style={{maxWidth:900,margin:"0 auto",padding:"32px 20px"}}>
        {msg?<div style={{background:"#f0fdf4",border:"1px solid #bbf7d0",borderRadius:8,padding:"10px 16px",fontSize:13,color:"#16a34a",marginBottom:16,fontWeight:600}}>{msg}</div>:null}
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #e5e7eb",padding:20,marginBottom:16,display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
          <div>
            <h1 style={{fontSize:20,fontWeight:700,color:"#1f2937",margin:0}}>{fuente.nombre_comercial||fuente.nombre_razon_social||"Sin nombre"}</h1>
            <p style={{fontSize:13,color:"#6b7280",fontFamily:"monospace",margin:"4px 0 0"}}>{fuente.rfc||"\u2014"}</p>
            <p style={{fontSize:12,color:"#9ca3af",margin:"4px 0 0"}}>Ultimo cambio: {fmtDate(fuente.fecha_ultimo_cambio)||"\u2014"}</p>
          </div>
          <div style={{display:"flex",gap:8}}>
            {canEdit&&!editando?<button onClick={iniciarEdicion} style={{display:"flex",alignItems:"center",gap:6,padding:"8px 16px",background:BRAND,color:"#fff",border:"none",borderRadius:8,fontSize:13,fontWeight:600,cursor:"pointer"}}>✏ Editar</button>:null}
            {editando?<><button onClick={guardar} disabled={saving} style={{display:"flex",alignItems:"center",gap:6,padding:"8px 16px",background:"#16a34a",color:"#fff",border:"none",borderRadius:8,fontSize:13,fontWeight:600,cursor:"pointer"}}>{saving?"Guardando...":"💾 Guardar"}</button><button onClick={cancelar} style={{padding:"8px 16px",background:"#f3f4f6",color:"#374151",border:"none",borderRadius:8,fontSize:13,fontWeight:600,cursor:"pointer"}}>✕ Cancelar</button></>:null}
          </div>
        </div>

        <Sec2 icon="👤" titulo="Identificacion">
          {editando?<div style={{display:"flex",gap:8,marginBottom:16}}>
            <button onClick={function(){setCampo("tipo_persona","fisica");}} style={{padding:"6px 14px",borderRadius:8,fontSize:12,fontWeight:600,border:"2px solid",cursor:"pointer",borderColor:esFisica?BRAND:"#d1d5db",background:esFisica?BRAND+"15":"#fff",color:esFisica?BRAND:"#6b7280"}}>Persona Fisica</button>
            <button onClick={function(){setCampo("tipo_persona","moral");}} style={{padding:"6px 14px",borderRadius:8,fontSize:12,fontWeight:600,border:"2px solid",cursor:"pointer",borderColor:!esFisica?BRAND:"#d1d5db",background:!esFisica?BRAND+"15":"#fff",color:!esFisica?BRAND:"#6b7280"}}>Persona Moral</button>
          </div>:null}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
            <Campo2 label="RFC" value={fuente.rfc} editable={editando} onChange={function(v){setCampo("rfc",v.toUpperCase());}}/>
            {esFisica?<Campo2 label="CURP" value={fuente.curp} editable={editando} onChange={function(v){setCampo("curp",v.toUpperCase());}}/>:null}
            <Campo2 label={esFisica?"Nombre":"Denominacion / Razon Social"} value={fuente.nombre_razon_social} editable={editando} onChange={function(v){setCampo("nombre_razon_social",v);}}/>
            {esFisica?<Campo2 label="Primer Apellido" value={fuente.primer_apellido} editable={editando} onChange={function(v){setCampo("primer_apellido",v);}}/>:null}
            {esFisica?<Campo2 label="Segundo Apellido" value={fuente.segundo_apellido} editable={editando} onChange={function(v){setCampo("segundo_apellido",v);}}/>:null}
            <Campo2 label="Nombre Comercial" value={fuente.nombre_comercial} editable={editando} onChange={function(v){setCampo("nombre_comercial",v);}}/>
            {!esFisica?<Campo2 label="Representante Legal" value={fuente.representante_legal} editable={editando} onChange={function(v){setCampo("representante_legal",v);}}/>:null}
          </div>
        </Sec2>

        <Sec2 icon="📅" titulo="Estatus y Vigencias">
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
            <Campo2 label="Fecha Inicio de Operaciones" value={fuente.fecha_inicio_ops} type="date" editable={editando} onChange={function(v){setCampo("fecha_inicio_ops",v);}}/>
            <Campo2 label="Inicio como Cliente Kofides" value={fuente.fecha_inicio_kofides} type="date" editable={editando} onChange={function(v){setCampo("fecha_inicio_kofides",v);}}/>
            <Campo2 label="Estatus" value={fuente.estatus} editable={editando} options={ESTATUS_OPTS} onChange={function(v){setCampo("estatus",v);}}/>
            <Campo2 label="Fecha Ultimo Cambio" value={fuente.fecha_ultimo_cambio} editable={false}/>
            <div>
              <label style={{fontSize:11,fontWeight:600,color:"#6b7280",textTransform:"uppercase",letterSpacing:"0.05em",display:"block",marginBottom:4}}>Vencimiento e.firma</label>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                {editando?<input type="date" value={fuente.venc_efirma||""} onChange={function(e){setCampo("venc_efirma",e.target.value);}} style={{flex:1,padding:"8px 12px",border:"1px solid #d1d5db",borderRadius:8,fontSize:14}}/>:<div style={{flex:1,padding:"8px 12px",background:"#f9fafb",borderRadius:8,fontSize:14}}>{fmtDate(fuente.venc_efirma)||"\u2014"}</div>}
                <VencBadge fecha={fuente.venc_efirma}/>
              </div>
            </div>
            <div>
              <label style={{fontSize:11,fontWeight:600,color:"#6b7280",textTransform:"uppercase",letterSpacing:"0.05em",display:"block",marginBottom:4}}>Vencimiento CSD</label>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                {editando?<input type="date" value={fuente.venc_csd||""} onChange={function(e){setCampo("venc_csd",e.target.value);}} style={{flex:1,padding:"8px 12px",border:"1px solid #d1d5db",borderRadius:8,fontSize:14}}/>:<div style={{flex:1,padding:"8px 12px",background:"#f9fafb",borderRadius:8,fontSize:14}}>{fmtDate(fuente.venc_csd)||"\u2014"}</div>}
                <VencBadge fecha={fuente.venc_csd}/>
              </div>
            </div>
          </div>
        </Sec2>

        <Sec2 icon="📄" titulo="Contacto">
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
            <Campo2 label="Email" value={fuente.email} editable={editando} onChange={function(v){setCampo("email",v);}}/>
            <Campo2 label="Telefono" value={fuente.telefono} editable={editando} onChange={function(v){setCampo("telefono",v);}}/>
          </div>
        </Sec2>

        <Sec2 icon="📍" titulo="Domicilio Fiscal">
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
            <Campo2 label="Codigo Postal" value={fuente.cp} editable={editando} onChange={function(v){setCampo("cp",v);}}/>
            <Campo2 label="Tipo de Vialidad" value={fuente.tipo_vialidad} editable={editando} options={TIPOS_VIALIDAD} onChange={function(v){setCampo("tipo_vialidad",v);}}/>
            <Campo2 label="Nombre de Vialidad" value={fuente.nombre_vialidad} editable={editando} onChange={function(v){setCampo("nombre_vialidad",v);}}/>
            <Campo2 label="Numero Exterior" value={fuente.num_exterior} editable={editando} onChange={function(v){setCampo("num_exterior",v);}}/>
            <Campo2 label="Numero Interior" value={fuente.num_interior} editable={editando} onChange={function(v){setCampo("num_interior",v);}}/>
            <Campo2 label="Colonia" value={fuente.colonia} editable={editando} onChange={function(v){setCampo("colonia",v);}}/>
            <Campo2 label="Localidad" value={fuente.localidad} editable={editando} onChange={function(v){setCampo("localidad",v);}}/>
            <Campo2 label="Municipio" value={fuente.municipio} editable={editando} onChange={function(v){setCampo("municipio",v);}}/>
            <Campo2 label="Entidad Federativa" value={fuente.entidad} editable={editando} onChange={function(v){setCampo("entidad",v);}}/>
          </div>
        </Sec2>

        <Sec2 icon="💼" titulo="Actividades Economicas">
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:14,marginBottom:16}}>
            <thead><tr style={{borderBottom:"2px solid #e5e7eb"}}>
              <th style={{padding:"8px",textAlign:"left",fontSize:11,fontWeight:600,color:"#6b7280",textTransform:"uppercase",width:60}}>Orden</th>
              <th style={{padding:"8px",textAlign:"left",fontSize:11,fontWeight:600,color:"#6b7280",textTransform:"uppercase"}}>Actividad Economica</th>
              <th style={{padding:"8px",textAlign:"left",fontSize:11,fontWeight:600,color:"#6b7280",textTransform:"uppercase",width:60}}>%</th>
              <th style={{padding:"8px",textAlign:"left",fontSize:11,fontWeight:600,color:"#6b7280",textTransform:"uppercase",width:130}}>Fecha Inicio</th>
              {canEdit?<th style={{padding:"8px"}}></th>:null}
            </tr></thead>
            <tbody>{actividades.map(function(a){return(<tr key={a.id} style={{borderBottom:"1px solid #f3f4f6"}}>
              <td style={{padding:"8px",fontSize:14}}>{a.orden!=null?a.orden:(a.order!=null?a.order:"-")}</td>
              <td style={{padding:"8px",fontSize:14}}>{a.descripcion}</td>
              <td style={{padding:"8px",fontSize:14}}>{a.porcentaje}%</td>
              <td style={{padding:"8px",fontSize:14}}>{fmtDate(a.fecha_inicio)||"—"}</td>
              {canEdit?<td style={{padding:"8px"}}><button onClick={function(){delActividad(a.id);}} style={{background:"none",border:"none",color:"#ef4444",cursor:"pointer",fontWeight:700}}>✕</button></td>:null}
            </tr>);})}</tbody>
          </table>
          {canEdit?<div style={{display:"grid",gridTemplateColumns:"2fr 80px 140px auto",gap:10,alignItems:"end",padding:"14px",background:"#f9fafb",borderRadius:8,border:"1px dashed #d1d5db"}}>
            <div><Lbl c="Descripcion"/><Inp value={nAct.descripcion} onChange={function(e){setNAct(function(a){return Object.assign({},a,{descripcion:e.target.value});});}} placeholder="Ej. Transporte de carga en general"/></div>
            <div><Lbl c="% Part."/><Inp type="number" min={1} max={100} value={nAct.porcentaje} onChange={function(e){setNAct(function(a){return Object.assign({},a,{porcentaje:e.target.value});}); }}/></div>
            <div><Lbl c="Fecha inicio"/><Inp type="date" value={nAct.fecha_inicio} onChange={function(e){setNAct(function(a){return Object.assign({},a,{fecha_inicio:e.target.value});});}}/></div>
            <Btn onClick={addActividad} sx={{padding:"9px 16px",whiteSpace:"nowrap"}}>Agregar</Btn>
          </div>:null}
        </Sec2>

        <Sec2 icon="🛡" titulo="Regimen Fiscal">
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
            <Campo2 label="Regimen Fiscal" value={fuente.regimen} editable={editando} options={REGIMENES_OPTS} onChange={function(v){setCampo("regimen",v);}}/>
          </div>
        </Sec2>

        <Sec2 icon="📋" titulo="Obligaciones Fiscales">
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:14,marginBottom:16}}>
            <thead><tr style={{borderBottom:"2px solid #e5e7eb"}}>
              <th style={{padding:"8px",textAlign:"left",fontSize:11,fontWeight:600,color:"#6b7280",textTransform:"uppercase"}}>Obligacion Aplicable</th>
              <th style={{padding:"8px",textAlign:"left",fontSize:11,fontWeight:600,color:"#6b7280",textTransform:"uppercase",width:130}}>Fecha Inicio</th>
              {canEdit?<th style={{padding:"8px",textAlign:"left",fontSize:11,fontWeight:600,color:"#6b7280",textTransform:"uppercase",width:140}}>Proximo Venc.</th>:null}
              {canEdit?<th style={{padding:"8px",width:36}}></th>:null}
            </tr></thead>
            <tbody>{obligaciones.map(function(o){
              var proximo=calcProximoVenc(o.nombre||o.descripcion,fuente.rfc,diasInhabiles,fuente.tipo_persona);
              return(<tr key={o.id} style={{borderBottom:"1px solid #f3f4f6"}}>
                <td style={{padding:"8px",fontSize:14}}>{o.nombre||o.descripcion}</td>
                <td style={{padding:"8px",fontSize:13,color:"#6b7280"}}>{fmtDate(o.fecha_inicio)||"—"}</td>
                {canEdit?<td style={{padding:"8px",fontSize:13,color:"#374151",fontWeight:500}}>{proximo?fmtDate(proximo):<span style={{color:"#9ca3af"}}>—</span>}</td>:null}
                {canEdit?<td style={{padding:"8px"}}><button onClick={function(){delObligacion(o.id);}} style={{background:"none",border:"none",color:"#ef4444",cursor:"pointer",fontWeight:700}}>✕</button></td>:null}
              </tr>);
            })}</tbody>
          </table>
          {canEdit?<div style={{display:"grid",gridTemplateColumns:"2fr 1fr auto",gap:10,alignItems:"end",padding:"14px",background:"#f9fafb",borderRadius:8,border:"1px dashed #d1d5db"}}>
            <div><Lbl c="Obligacion"/><Slct value={nObl.nombre} onChange={function(e){setNObl(function(o){return Object.assign({},o,{nombre:e.target.value});});}}><option value="">Seleccionar...</option>{catObl.map(function(c){return <option key={c} value={c}>{c}</option>;})}</Slct></div>
            <div><Lbl c="Fecha Inicio"/><Inp type="date" value={nObl.fecha_inicio} onChange={function(e){setNObl(function(o){return Object.assign({},o,{fecha_inicio:e.target.value});});}}/></div>
            <Btn onClick={addObligacion} sx={{padding:"9px 16px",whiteSpace:"nowrap"}}>Agregar</Btn>
          </div>:null}
        </Sec2>

        <Sec2 icon="📁" titulo="Documentos Fiscales">
          {canEdit?<div style={{marginBottom:20,padding:16,background:"#eef2ff",border:"1px solid #c7d2fe",borderRadius:8}}>
            <p style={{fontSize:12,fontWeight:600,color:BRAND,margin:"0 0 12px"}}>Subir nuevo documento (solo administrador / contador)</p>
            <div style={{display:"flex",gap:8}}>
              <select value={tipoNuevoDoc} onChange={function(e){setTipoNuevoDoc(e.target.value);}} style={{flex:1,padding:"8px 12px",border:"1px solid #d1d5db",borderRadius:8,fontSize:13}}>{catDoc.map(function(t){return <option key={t} value={t}>{t}</option>;})}</select>
              <input ref={fileInputRef} type="file" accept=".pdf,.xml,.jpg,.png" onChange={subirDocumento} style={{display:"none"}}/>
              <button onClick={function(){fileInputRef.current&&fileInputRef.current.click();}} style={{display:"flex",alignItems:"center",gap:6,padding:"8px 16px",background:BRAND,color:"#fff",border:"none",borderRadius:8,fontSize:13,fontWeight:600,cursor:"pointer"}}>⬆ Seleccionar archivo</button>
            </div>
            <p style={{fontSize:11,color:"#9ca3af",margin:"8px 0 0"}}>Formatos: PDF, XML, JPG, PNG</p>
          </div>:null}
          {documentos.length===0?<div style={{textAlign:"center",padding:"32px 0",color:"#9ca3af",fontSize:13}}>No hay documentos cargados</div>:
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:14}}>
            <thead><tr style={{borderBottom:"2px solid #e5e7eb"}}>
              <th style={{padding:"8px",textAlign:"left",fontSize:11,fontWeight:600,color:"#6b7280",textTransform:"uppercase"}}>Tipo</th>
              <th style={{padding:"8px",textAlign:"left",fontSize:11,fontWeight:600,color:"#6b7280",textTransform:"uppercase"}}>Archivo</th>
              <th style={{padding:"8px",textAlign:"left",fontSize:11,fontWeight:600,color:"#6b7280",textTransform:"uppercase"}}>Fecha</th>
              <th style={{padding:"8px",textAlign:"left",fontSize:11,fontWeight:600,color:"#6b7280",textTransform:"uppercase"}}>Acciones</th>
            </tr></thead>
            <tbody>{documentos.map(function(d){return(<tr key={d.id} style={{borderBottom:"1px solid #f3f4f6"}}>
              <td style={{padding:"8px",fontSize:14,fontWeight:500}}>{d.tipo}</td>
              <td style={{padding:"8px",fontSize:12,fontFamily:"monospace",color:"#6b7280"}}>{d.nombre_archivo}</td>
              <td style={{padding:"8px",fontSize:13,color:"#6b7280"}}>{fmtDate(d.fecha_subida)||"—"}</td>
              <td style={{padding:"8px"}}><div style={{display:"flex",gap:8}}>
                <button onClick={function(){downloadDoc(d.id);}} style={{display:"flex",alignItems:"center",gap:4,padding:"6px 12px",border:"1px solid #16a34a",borderRadius:6,background:"#fff",color:"#16a34a",fontSize:12,fontWeight:600,cursor:"pointer"}}>⬇ Descargar</button>
                {canEdit?<button onClick={function(){delDocumento(d.id);}} style={{padding:"6px 10px",border:"1px solid #fecaca",borderRadius:6,background:"#fef2f2",color:"#ef4444",fontSize:12,cursor:"pointer"}}>🗑</button>:null}
              </div></td>
            </tr>);})}</tbody>
          </table>}
          {!canEdit?<p style={{fontSize:12,color:"#9ca3af",marginTop:12}}>Los documentos son cargados por tu contador.</p>:null}
        </Sec2>

        {canEdit?<div style={{background:"#fff",borderRadius:12,border:"2px solid #fde68a",overflow:"hidden",marginBottom:16}}>
          <div style={{display:"flex",alignItems:"center",gap:8,padding:"12px 20px",background:"linear-gradient(to right,#fffbeb,#fff)",borderBottom:"1px solid #fef3c7"}}>
            <span style={{fontSize:16}}>🛡</span>
            <h3 style={{fontSize:14,fontWeight:600,color:"#1f2937",margin:0}}>Administrar Dias Inhabiles (CFF)</h3>
            <span style={{marginLeft:"auto",fontSize:11,fontWeight:600,color:"#92400e",background:"#fef3c7",padding:"2px 10px",borderRadius:20}}>Solo administrador / contador</span>
          </div>
          <div style={{padding:20}}>
            <p style={{fontSize:12,color:"#6b7280",marginBottom:16}}>Catalogo de festivos del Art. 12 del CFF. No incluye periodos vacacionales del SAT.</p>
            <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:12}}>
              <span style={{fontSize:13,fontWeight:600,color:"#374151"}}>Festivos del año</span>
              <select value={anioTrabajo} onChange={function(e){setAnioTrabajo(Number(e.target.value));}} style={{padding:"6px 10px",border:"1px solid #d1d5db",borderRadius:6,fontSize:13}}>
                {anios.map(function(a){return <option key={a} value={a}>{a}</option>;})}
                <option value={new Date().getFullYear()+1}>{new Date().getFullYear()+1}</option>
              </select>
            </div>
            <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:12}}>
              {diasDelAnio.length===0?<span style={{fontSize:12,color:"#9ca3af"}}>Sin festivos para {anioTrabajo}</span>:
              diasDelAnio.map(function(d){return(<span key={d.fecha} style={{display:"inline-flex",alignItems:"center",gap:6,padding:"4px 12px",background:"#fffbeb",border:"1px solid #fde68a",borderRadius:20,fontSize:12,color:"#92400e"}}>
                {d.fecha}<button onClick={function(){delDia(d.fecha);}} style={{background:"none",border:"none",color:"#d97706",cursor:"pointer",fontWeight:700}}>×</button>
              </span>);})}
            </div>
            <div style={{display:"flex",gap:8,alignItems:"center"}}>
              <input type="date" value={nuevaFecha} onChange={function(e){setNuevaFecha(e.target.value);}} style={{padding:"8px 12px",border:"1px solid #d1d5db",borderRadius:8,fontSize:13}}/>
              <button onClick={addDia} style={{padding:"8px 16px",background:"#d97706",color:"#fff",border:"none",borderRadius:8,fontSize:13,fontWeight:600,cursor:"pointer"}}>+ Agregar festivo {anioTrabajo}</button>
            </div>
          </div>
        </div>:null}

        {canEdit?<div style={{background:"#fff",borderRadius:12,border:"2px solid #c7d2fe",overflow:"hidden",marginBottom:16}}>
          <div style={{display:"flex",alignItems:"center",gap:8,padding:"12px 20px",background:"linear-gradient(to right,#eef2ff,#fff)",borderBottom:"1px solid #e0e7ff"}}>
            <span style={{fontSize:16}}>📋</span>
            <h3 style={{fontSize:14,fontWeight:600,color:"#1f2937",margin:0}}>Catalogo de Obligaciones Fiscales</h3>
            <span style={{marginLeft:"auto",fontSize:11,fontWeight:600,color:"#3730a3",background:"#e0e7ff",padding:"2px 10px",borderRadius:20}}>Solo administrador / contador</span>
          </div>
          <div style={{padding:20}}>
            <p style={{fontSize:12,color:"#6b7280",marginBottom:16}}>Define las obligaciones disponibles para asignar a clientes. Los cambios aplican a todos los clientes.</p>
            <div style={{display:"flex",flexDirection:"column",gap:4,marginBottom:16,maxHeight:240,overflowY:"auto"}}>
              {catObl.map(function(c){return(
                <div key={c} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"7px 12px",background:"#f9fafb",borderRadius:8,border:"1px solid #e5e7eb"}}>
                  <span style={{fontSize:13,color:"#1f2937"}}>{c}</span>
                  <button onClick={function(){delCatObl(c);}} style={{background:"none",border:"none",color:"#ef4444",cursor:"pointer",fontWeight:700,fontSize:14,lineHeight:1}}>✕</button>
                </div>
              );})}
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr auto",gap:10,alignItems:"end",padding:"14px",background:"#f9fafb",borderRadius:8,border:"1px dashed #c7d2fe"}}>
              <div>
                <label style={{fontSize:11,fontWeight:600,color:"#6b7280",textTransform:"uppercase",letterSpacing:"0.05em",display:"block",marginBottom:4}}>Nueva obligacion</label>
                <input value={nCatObl.nombre} onChange={function(e){setNCatObl(function(o){return Object.assign({},o,{nombre:e.target.value});});}} placeholder="Ej. ISR mensual (pagos provisionales)" style={{width:"100%",padding:"8px 12px",border:"1px solid #d1d5db",borderRadius:8,fontSize:13,boxSizing:"border-box",outline:"none"}}/>
              </div>
              <button onClick={addCatObl} disabled={savingCat||!nCatObl.nombre.trim()} style={{padding:"9px 18px",background:BRAND,color:"#fff",border:"none",borderRadius:8,fontSize:13,fontWeight:600,cursor:"pointer",whiteSpace:"nowrap",opacity:savingCat||!nCatObl.nombre.trim()?0.5:1}}>{savingCat?"Guardando...":"+ Agregar"}</button>
            </div>
          </div>
        </div>:null}
      </div>
    </div>
  );
}